export default "__VITE_ASSET__5825fccc__"